import api from "./api";
class DepositoService {
    static async minhaListaDepositos() {
        const res = await api.get(`restrito/depositos/minha-lista`);
        return res.data;
    }
}
export default DepositoService;
